export default __webpack_public_path__ + "static/media/more.c1968f37.svg";